import toast from "react-hot-toast";
import { IAgentData } from "types/interface";

const routes = {
  noCodeApiGoogleSheet:
    "https://v1.nocodeapi.com/dotpayafrica1/google_sheets/cMvgdpvfqMFVVRKR?tabId=sheet1",
};
export const sendToGoogleSheet = async (data: IAgentData) => {
  try {
    const { fullname, email, phone, state, lga, referralCode } = data;
    fetch(routes.noCodeApiGoogleSheet, {
      method: "post",
      body: JSON.stringify([
        [fullname, email, phone, state, lga, '-', referralCode],
      ]),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response: any) => response.json())
      .then((result: any) => {
        console.log(result);
        if (result.error) {
          toast.error(result.info);
        } else {
          toast.success("Successful");
        }
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
  } catch (error) {
    console.error("Error:", error);
  }
};
